import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AddProduct() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    unit: 'kg',
    quantity: '',
    category: 'vegetables',
    organic: false,
    isSingleItem: false,
  });
  const [images, setImages] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      if (name === 'isSingleItem' && checked) {
        setFormData(prev => ({ ...prev, isSingleItem: true, quantity: 1 }));
      } else {
        setFormData(prev => ({ ...prev, [name]: checked }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
    setPreviewUrls(files.map(file => URL.createObjectURL(file)));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formDataToSend = new FormData();
    Object.keys(formData).forEach(key => formDataToSend.append(key, formData[key]));
    images.forEach(image => formDataToSend.append('images', image));

    try {
      const res = await fetch('/api/products', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: formDataToSend
      });
      if (!res.ok) throw new Error(await res.text());
      navigate('/my-products');
    } catch (error) {
      console.error(error);
      alert('Failed to create product');
    } finally {
      setLoading(false);
    }
  };

  const categories = ['vegetables', 'fruits', 'dairy', 'meat', 'eggs', 'honey', 'livestock', 'other'];
  const units = ['kg', 'lb', 'each', 'bunch', 'dozen'];

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-6">Add New Product</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div><label className="block text-gray-700 mb-2">Product Name *</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required /></div>
          <div><label className="block text-gray-700 mb-2">Description *</label>
            <textarea name="description" value={formData.description} onChange={handleChange} rows="4" className="w-full border rounded-md px-3 py-2" required /></div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-gray-700 mb-2">Price *</label>
              <input type="number" name="price" value={formData.price} onChange={handleChange} step="0.01" min="0" className="w-full border rounded-md px-3 py-2" required /></div>
            <div><label className="block text-gray-700 mb-2">Unit *</label>
              <select name="unit" value={formData.unit} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required>
                {units.map(unit => <option key={unit} value={unit}>{unit}</option>)}
              </select></div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-gray-700 mb-2">Quantity *</label>
              <input type="number" name="quantity" value={formData.quantity} onChange={handleChange} min="0" disabled={formData.isSingleItem} className="w-full border rounded-md px-3 py-2" required /></div>
            <div><label className="block text-gray-700 mb-2">Category *</label>
              <select name="category" value={formData.category} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required>
                {categories.map(cat => <option key={cat} value={cat}>{cat.charAt(0).toUpperCase() + cat.slice(1)}</option>)}
              </select></div>
          </div>
          <div className="flex items-center space-x-4">
            <label className="flex items-center"><input type="checkbox" name="organic" checked={formData.organic} onChange={handleChange} className="mr-2" /><span>Organic</span></label>
            <label className="flex items-center"><input type="checkbox" name="isSingleItem" checked={formData.isSingleItem} onChange={handleChange} className="mr-2" /><span>Unique item (only 1 available)</span></label>
          </div>
          <div><label className="block text-gray-700 mb-2">Product Images</label>
            <input type="file" onChange={handleImageChange} multiple accept="image/*" className="w-full border rounded-md px-3 py-2" />
            {previewUrls.length > 0 && <div className="mt-2 grid grid-cols-4 gap-2">{previewUrls.map((url, i) => <img key={i} src={url} alt="preview" className="w-full h-20 object-cover rounded" />)}</div>}
          </div>
          <button type="submit" disabled={loading} className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 transition disabled:bg-gray-400">{loading ? 'Adding...' : 'Add Product'}</button>
        </form>
      </div>
    </div>
  );
}
